import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { CardLayout } from '@/components/layouts/index.tsx';

const Custom500 = () => {
  const { t } = useTranslation(['common', '500']);

  return (
    <>
      <img
        alt="Furality logo"
        src="https://media.cdn.furality.online/image/logo/fox-logo.svg"
        className="img-fluid img-center mt-5"
        style={{ maxWidth: '20rem' }}
      />
      <div className="mt-5 mb-5 text-center">
        <h1 className="h2">{t('shared.navigation.500')}</h1>
        <p className="lead">{t('500:content')}</p>
        <h3>
          <Link to="/" className="text-underline text-info">
            {t('shared.back_to_portal')}
          </Link>
        </h3>
      </div>
    </>
  );
};

export const Route = createFileRoute('/500')({
  component: () => (
    <CardLayout title="shared.navigation.500">
      <Custom500 />
    </CardLayout>
  ),
});
